<script>
  import { fade } from "svelte/transition";
	import Load from "../components/Load.svelte" 
  import Default from "../components/form/Default.svelte";

  import Kpt from "../components/form/Kpt.svelte";

  import Na from "../components/form/Na.svelte";

  import Skdu from "../components/form/Skdu.svelte";

  import Skk from "../components/form/Skk.svelte";

  import Skkk from "../components/form/Skkk.svelte";

  import Skoy from "../components/form/Skoy.svelte";

  import Sku from "../components/form/Sku.svelte";

  import Skw from "../components/form/Skw.svelte";

  import Ektp from "../components/form/Ektp.svelte";
  import Skpd from "../components/form/Skpd.svelte";

  import Alert from "../components/Alert.svelte";
  import Title from "../components/Title.svelte";
  import Accordion from "../components/accordion/Accordion.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import FileInput from "../components/FileInput/FileInput.svelte";

  import * as htmlToImage from "html-to-image";
  import {serialize} from "form-serialization";
 
  function handleFileSelect(file) {
    
    var f = file.detail.files[0]; // FileList object
    if (f) {
      if (/(jpe?g|png|gif)$/i.test(f.type)) {
        var reader = new FileReader();

        // Closure to capture the file information.
        reader.onload = (function (theFile) {
          return function (e) {
            var binaryData = e.target.result;

            document.getElementById("base64pengantar").value = binaryData;
            document.getElementById("img").innerHTML =
              '<img alt="Pengantar" class="w-full rounded-lg" src="' +
              binaryData +
              '">';
            document.getElementById("next").style.display = "block";
          };
        })(f);
        reader.readAsDataURL(f);
      } else {
        alert = [
          ...alert,
          {
            message: "File yang dapat diproses berupa .jpg,jpeg,png,gif",
            color: "orange",
          },
        ];
      }
    } else {
      alert = [
        ...alert,
        {
          message: "File tidak ditemukan",
          color: "orange",
        },
      ];
    }
  }

  //liblary
  import axios from "axios";

  import { session } from "../components/js/notif.js"; 
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  

  let loading = false;

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nama_pen;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = []; 
  let items = [];
  let cameraDisplay = false;
  function togglecameraDisplay() {
    if (!cameraDisplay) {
      openCameraUI();
      cameraDisplay = !cameraDisplay;
    } else {
      setTimeout(() => {
        cameraDisplay = !cameraDisplay;
        if (window.stream) {
          window.stream.getTracks().forEach(function (track) {
            
            track.stop();
          });
        }
      }, 1000);
    }
  }
  let itemsDisplay = false;

  let step = 1;
  function nextStep() {
    loading = true;
    if (document.getElementsByClassName("tablist").length >= step - 1) {
      document.getElementById("stepID" + step).className = "";
      document.getElementById("stepcontID" + step).style.display = "none";
      step = step + 1;
      document.getElementById("stepID" + step).className = "active";
      document.getElementById("stepcontID" + step).style.display = "block";
      loading = false;
    }
  }

  function backStep() {
    loading = true;
    if (document.getElementsByClassName("tablist").length <= step - 1) {
      document.getElementById("stepID" + step).className = "";
      document.getElementById("stepcontID" + step).style.display = "none";
      step = step - 1;
      document.getElementById("stepID" + step).className = "active";
      document.getElementById("stepcontID" + step).style.display = "block";
    loading = false;
    }
  }

  let datasrt;
  let dataapi;
  let datanik;

  function openForm(id) {
    loading = true;
    let nik = document.getElementById(id).getAttribute("data-id");
    let api = document.getElementById(id).getAttribute("data-api");
    let rel = document.getElementById(id).getAttribute("data-rel");
    datasrt = rel;
    
    dataapi = api;
    datanik = nik;
    if (document.getElementById(id).getAttribute("data-api") != "") {
    } else {
    }
    setTimeout(() => {
      
    loading = false;
    }, 1500);
  }
  function loadLay() {
    loading = true;
    axios
      .get(settings.url + "/sipade/lay/" + settings.data.pen.nik, {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        items = response.data;
        
        if (response.data) {
          setTimeout(() => {
            itemsDisplay = true;
            
    loading = false;
          }, 2000);
        }
      })
      .catch(function (error) {        
        loading = false;
        
        itemsDisplay = false;
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/login");
        } else {
          if (error.response.data.message) {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: error.response.data.message,
                color: "orange",
              },
            ];
          } else {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: "Anda belum terhubung dengan baik",
                color: "orange",
              },
            ];
          }
        }
      });
  }
  $: if (settings.loggedin == true) {
    loadLay();
  }

  let uid = Math.random().toString(36).substring(2);


  // we're going to use async await for a cleaner syntax
  let onSubmit = async () => {     
    var form = document.querySelector('#capture');
const formData = serialize(form, {hash: true});
    loading = true; 
     
    var el = document.getElementById("capture");

    htmlToImage
      .toPng(el,{
    filter:function(node){
      if(node.nodeType===1){ 
        if(node.tagName==="INPUT" && (""+node.type).toLowerCase() === "checkbox"){ 
          if(node.checked){
            node.setAttribute('checked', true);
          }else{
            node.removeAttribute('checked');
          }
        }
        else if(node.tagName==="SELECT" && node.selectedIdx!=-1){
          var options = node.childNodes; // Assumption!
          var optionCount = 0;
          var selectedIdx = node.selectedIndex;
          for(var i=0; i<options.length; i++){
            var option = options[i]; // Maybe not an option
            if(option.tagName==="OPTION"){
              if(optionCount === selectedIdx)
              {
                options[i].setAttribute('selected', true);
              }
              else
              {
                options[i].removeAttribute('selected');
              }
              optionCount++;
            }
            
          }
          
          
        }
      }
      return true;
    }
  })
      .then(function (dataUrl) {
        var img = new Image();
        img.src = dataUrl;
        document.querySelector("#canvasContainer").appendChild(img);
        document.getElementById("base64pengantar").value = img;
        
    loading = false;
      })
      .catch(function (error) {
        console.error("oops, something went wrong!", error);
      }); 
      console.log(formData)
      console.log(JSON.stringify(formData))
     
      
    axios
      .post("https://testpelayanan.d/", formData)
      .then(function (response) {
        
        if (response.data.status) {
          result = response.data;
          autoRefresh = true;
        }
        if (response.data.status == false) {
          alertMessage = response.data.message;
          alert = [...alert, { title: "Dekatan", message: alertMessage, color: "orange" }];
        }
      })
      .catch(function (error) {
        
        alertMessage = "Tidak Terhubung Dengan Baik";
        alert = [...alert, { title: "Dekatan", message: alertMessage, color: "orange" }];
      })

  };
</script>

<svelte:head>
  <link rel="stylesheet" href="./assets/camera/style.css" />
  <script src="./assets/camera/js/howler.core.min.js">
  </script>
  <script src="./assets/camera/js/adapter.min.js">
  </script>
  <script src="./assets/camera/js/screenfull.min.js">
  </script>
  <script src="./assets/camera/js/main.js">
  </script>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 left-0 right-0 z-10 w-full px-2 mb-10 lg:left-auto lg:w-3/12">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar
  backbtn="true"
  message={navigation['message']}
  title="Pelayanan" />
<main transition:fade class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0">
  {#if loading}  
  <div class="fixed top-0 left-0 right-0 z-50 w-screen h-2 bg-green-500 animate-pulse"></div>
  {/if}
  <div class="max-w-6xl pt-2 mx-auto my-5 lg:my-0">
    <div class="lg:hidden">
      <Title subtitle="" title="Ajukan Pelayanan" />
    </div>

    {#if itemsDisplay}
      <div class="max-w-4xl mx-auto overflow-x-auto rounded-lg">
        <div class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 ">
          <div class="w-full mx-auto mb-2">
            <div class="block px-4 py-3 bg-white rounded-md shadow-md group">
              <ul class="mt-5 list-unstyled multi-steps tablist">
                <li role="presentation" id="stepID1" class="active">
                  <span class="text-sm">Pengantar RT</span>
                </li>
                <li role="presentation" id="stepID2">
                  <span class="text-sm">Pilih Pelayanan</span>
                </li>
                <li role="presentation" id="stepID3">
                  <span class="text-sm">Isi Formulir</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 "
          id="canvasResource">
          <div class="w-full mx-auto mb-2">
            <div class="block px-4 py-3 bg-white rounded-md shadow-md group">
              <div id="stepcontID1" class="block stepcontID">
                <p
                  class="w-full p-3 mx-auto mt-5 text-xs text-center text-blue-800 bg-blue-300 rounded lg:w-3/4 ">
                  Siapkan Surat Pengantar Ketua RT setempat, lalu foto surat
                  tersebut menggunakan pemindai dibawah ini
                </p>
                <textarea
                  id="base64screenshoot"
                  name="screenshoot"
                  class="hidden" />
                <textarea
                  id="base64pengantar"
                  name="pengantar"
                  class="hidden" />

                <div
                  on:click={togglecameraDisplay}
                  class="relative clear-both w-3/4 px-5 m-2 mx-auto text-center bg-orange-300 rounded cursor-pointer lg:w-3/6 hover:shadow-lg">
                  <svg
                    class="inline-block w-12 h-12 text-gray-800 stroke-current"
                    viewBox="0 0 48 48"
                    enable-background="new 0 0 48 48">
                    <path
                      fill="#607D8B"
                      d="M40,39H8c-2.2,0-4-1.8-4-4V13c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v22C44,37.2,42.2,39,40,39z" />
                    <circle fill="#455A64" cx="29" cy="24" r="12" />
                    <circle fill="#42A5F5" cx="29" cy="24" r="9" />
                    <path
                      fill="#90CAF9"
                      d="M33.8,21c-1.2-1.4-3-2.2-4.8-2.2s-3.6,0.8-4.8,2.2c-0.5,0.5-0.4,1.3,0.1,1.8c0.5,0.5,1.3,0.4,1.8-0.1
                      c1.5-1.7,4.3-1.7,5.8,0c0.3,0.3,0.6,0.4,1,0.4c0.3,0,0.6-0.1,0.9-0.3C34.2,22.4,34.3,21.5,33.8,21z" />
                    <rect x="8" y="13" fill="#ADD8FB" width="6" height="3" />
                  </svg>
                  Pindai Pengantar
                </div>
                <div class="mt-5 separator">atau</div>
                <div
                  class="relative flex items-center justify-center w-full h-screen my-5 bg-gray-200">
                  <div
                    id="img"
                    class="absolute top-0 left-0 flex flex-row items-center justify-center w-full h-full overflow-hidden rounded-lg" />

                  <FileInput
                    let:dragging
                    multiple={true}
                    on:input={handleFileSelect}>
                    <div
                      class="shadow-xl {!dragging ? 'border-dashed border-4 border-gray-500' : 'shadow border-dotted border-4 border-gray-500'} absolute left-0 top-0 w-full h-full text-blue-800 rounded-lg shadow-lg tracking-wide cursor-pointer pt-56 hover:bg-blue-200  bg-white opacity-75 text-center">
                      <div style="top:40%" class="absolute w-full text-center">
                        <svg
                          class="w-8 h-8 mx-auto"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"><path
                            d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" /></svg>

                        <span class="font-bold uppercase ">Ambil dari
                          penyimpanan</span><br />
                        {!dragging ? 'Seret File Gambar Kesini' : 'Ok Lepaskan Filenya'}
                      </div>
                    </div>
                  </FileInput>
                </div>

                <div
                  id="next"
                  class="relative hidden clear-both w-3/4 px-5 py-2 m-2 mx-auto text-center text-white bg-green-600 rounded cursor-pointer lg:w-3/6 hover:shadow-lg"
                  on:click={nextStep}>
                  Selanjutnya
                </div>
              </div>
              <div id="stepcontID2" class="hidden stepcontID">
                <p
                  class="w-full p-3 mx-auto mt-5 text-xs text-center text-blue-800 bg-blue-300 rounded lg:w-3/4 ">
                  Pilih kategori dan jenis surat yang ingin diajukan dibawah ini
                </p>

                <div class="max-w-xl mx-auto">
                  {#each items.surat as kategori}
                    <Accordion
                      css="bg-gray-200 w-full rounded-t px-3 py-2 mt-2
                    cursor-pointer hover:bg-gray-300 accordion"
                      title={kategori.jns_S}>
                      {#each kategori.opsi as surat}
                        <label
                          class="block p-2 mt-1 bg-white rounded-md shadow-md hover:bg-gray-300"
                          id={surat.skt}
                          data-api={surat.api}
                          data-id={items.pen.nik}
                          data-rel={surat.skt}
                          data-jdl={surat.nm}
                          on:click={nextStep}
                          on:click={openForm(surat.skt)}>
                          <input
                            type="radio"
                            name="surat"
                            value={surat.id}
                            class="trigger" />
                          <span
                            class="float-right px-1 py-px m-px text-xs text-gray-200 bg-gray-800 rounded-full">
                            {surat.skt}
                          </span>
                          {surat.nm}
                        </label>
                      {/each}
                    </Accordion>
                  {/each}
                </div>

                <div
                  id="back"
                  class="relative clear-both w-3/4 px-5 py-2 m-2 mx-auto text-center text-white bg-orange-600 rounded cursor-pointer lg:w-3/6 hover:shadow-lg"
                  on:click={backStep}>
                  Kembali
                </div>
              </div>
              <div id="stepcontID3" class="hidden stepcontID">
                 
                <form method="POST" class="relative pb-10" id="capture">
                  {#if datasrt == 'SKPD'}
                    <Title
                      subtitle="Surak Keterangan Pindah Datang"
                      title="SKPD" />
                    <Skpd {settings} {dataapi} {datanik} />
                  {:else if datasrt == 'EKTP'}
                    <Title subtitle="Formulir Pengantar EKTP" title="EKTP" />
                    <Ektp />
                  {:else if datasrt == 'SKW'}
                    <Title subtitle="Keterangan Kematian/Wafat" title="SKW" />
                    <Skw />
                  {:else if datasrt == 'SKU'}
                    <Title subtitle="Keterangan Usaha" title="SKU" />
                    <Sku {settings} {dataapi} {datanik} />
                  {:else if datasrt == 'SKDU'}
                    <Title subtitle="Keterangan Usaha" title="SKDU" />
                    <Skdu {settings} {dataapi} {datanik} />
                  {:else if datasrt == 'SKOYS'}
                    <Title subtitle="Keterangan Orang Yang Sama" title="SKOY" />
                    <Skoy />
                  {:else if datasrt == 'SKKK'}
                    <Title
                      subtitle="Keterangan Kegiatan Keramaian"
                      title="SKKK" />
                    <Skkk />
                  {:else if datasrt == 'SKK'}
                    <Title subtitle="Keterangan Kelahiran" title="SKK" />
                    <Skk {settings} {dataapi} {datanik} />
                  {:else if datasrt == 'NA'}
                    <Title subtitle="Keterangan Nikah/Akad" title="NA" />
                    <Na {settings} {dataapi} {datanik} />
                  {:else if datasrt == 'KPT'}
                    <Title subtitle="Kartu Pelayanan Terpadu" title="KPT" />
                    <Kpt />
                  {:else}
                    <Default {settings} {dataapi} {datanik} />
                  {/if}
                </form> 
                <div id="canvasContainer" />
                <div class="flex justify-between gap-2">

                  <button
                    id="back"
                    class="relative clear-both w-3/4 px-5 py-2 m-2 mx-auto text-center text-white bg-orange-600 rounded cursor-pointer lg:w-3/6 focus:bg-gray-500 focus:outline-none hover:shadow-lg"
                    on:click={backStep}>
                    Kembali
                  </button>
                  <button
                    type="button"
                    id="back"
                    class="relative clear-both w-3/4 px-5 py-2 m-2 mx-auto text-center text-white bg-green-600 rounded outline-none cursor-pointer lg:w-3/6 focus:bg-gray-500 focus:outline-none hover:shadow-lg"
                    on:click={onSubmit}>
                    Kirim
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    {:else} 
    <p class="w-full p-5 font-light text-center text-gray-500 bg-white rounded shadow-md">Sepertinya Desa anda belum mendukung layanan ini</p>
 
    {/if}
  </div>
</main>
{#if cameraDisplay}
  <div id="container">
    <div id="vid_container">
      <video id="video" autoplay playsinline><track kind="captions" /></video>
      <div id="video_overlay" />
    </div>
    <div id="gui_controls">
      <button id="closeCamButton" on:click={togglecameraDisplay}>Batal</button>
      <button
        id="switchCameraButton"
        name="switch Camera"
        type="button"
        aria-pressed="true"
        style="display: block;" />
      <button
        id="takePhotoButton"
        on:click={togglecameraDisplay}
        name="take Photo"
        type="button" />
      <button
        id="toggleFullScreenButton"
        name="toggle FullScreen"
        type="button"
        aria-pressed="false" />
    </div>
  </div>
{/if}
